<template>
		<!-- <div v-for="(item,i) in data" :key="item.code+i">
			<span class="tree-item isTrue" v-if="!item.children" @click="onOpends(item,i)">{{item.name}}</span>
			<p class="isTrue" v-if="item.children">
				<label class="tree-item" @click="onOpends(item,i)">{{item.name}}</label>
				<tree-item class="children-box" :data="item.children" v-show="opends[i]"></tree-item>
			</p>
		</div> -->
		<div>
		<el-menu style="text-align: left;background-color:#f3f3f3;" :default-openeds="openeds"  v-for="(item,i) in allpermision">
			<el-submenu  :index="item.code">
				<template slot="title" v-if="item.children.length>0"><i class="el-icon-menu"></i>{{item.name}}</template>
				    <el-menu-item-group style="background-color:#ffffff;" v-for="(item1,i1) in item.children" >
				        <el-menu-item style="background-color:#ffffff;" :index="item1.code"  @click="onOpends(item1)">{{item1.name}}</el-menu-item>
				    </el-menu-item-group>
				</el-submenu>
				</el-menu>
			</div>
		<!-- <el-container style="width: 200px">
			<el-tree :data="allpermision" default-expand-all node-key="code"
			 :props="defaultProps" @node-click="onOpends">
			</el-tree>
		</el-container> -->
</template>

<script>
	import permission from '../apifunction/Permission.js'
	import commfun from '../commontools/CommonFun.js'
	export default {
		name: "tree-item",
		data() {
			return {
				allpermision:[],
				permissionlist: [],
				openeds:[],
				defaultProps: {
					children: "children",
					label: "name"
				},
			};
		},
		mounted() {
			this.GetPermissionByRoleID();
		},
		methods: {
			onOpends(data) {
				this.$router.push(data.url)
			},
			GetPermissionByRoleID() {
				// let roleid=this.$myglobal.userinfo.roleid;
				//alert(this.$myglobal.getUserInfo());
				let roleid=this.$myglobal.getUserInfo().roleid;
				permission.GetPermissionByRoleID(roleid)
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							
							this.permissionlist = JSON.parse(ent.Data);
							//this.$message.success(JSON.stringify(this.permissionlist))
							this.allpermision=commfun.getPermissionJson(this.permissionlist)
							this.openeds.push(this.allpermision[0].code)
						}
					})
			}
		}
	}
</script>

<style>

</style>
